import ReactDOM from 'react-dom'

export default (context: any): boolean => {
  const element = ReactDOM.findDOMNode(context) as any

  return element && element.offsetHeight > 0
}
